export default "__VITE_PUBLIC_ASSET__6e10a1a9__"